import React from "react"
import { XMarkIcon } from '@heroicons/react/24/solid';
import { Card, CardFooter, CardHeader, CardTitle, CardContent, CardDescription, CardAction, Button, Label, Input } from '../../shadcnComponents/ui'

export function NewGroupInput(props) {
    function handleCreate() {
        if (document.getElementById("group-name").value != "") {
            props.createGroup(document.getElementById("group-name").value);
            document.getElementById('group-name').value = '';
            document.getElementById('group-name').required = false
            document.getElementById('new-group').classList.add('hidden');
        } else {
            document.getElementById("group-name").required = true
        }
    }

    function closeDialogue() {
        document.getElementById('group-name').value = '';
        document.getElementById('group-name').required = false
        document.getElementById('new-group').classList.add('hidden');
    }

    return (
        <div id='new-group' className="hidden fixed z-10 w-screen h-screen top-0 left-0 bg-secondary-background flex items-center justify-center">
            <Card className='w-[40rem]'>
                <CardHeader>
                    <CardTitle>Νέα ομάδα</CardTitle>
                    <CardDescription>
                        Δώστε ένα όνομα για τη νέα ομάδα
                    </CardDescription>
                    <CardAction>
                        <Button onClick={() => { closeDialogue() }} variant="link">
                            <XMarkIcon className='size-6' />
                        </Button>
                    </CardAction>
                </CardHeader>
                <CardContent>
                    <form>
                        <div className="flex flex-col gap-6">
                            <div className="grid gap-2">
                                <Label htmlFor="text">Όνομα</Label>
                                <Input
                                    id="group-name"
                                    type="text"
                                    placeholder="Όνομα ομάδας"
                                />
                            </div>
                        </div>
                    </form>
                </CardContent>
                <CardFooter className='gap-5 w-full justify-end'>
                    <Button onClick={() => { handleCreate() }} variant={'yes'} >
                        Δημιουργία
                    </Button>
                    <Button variant={'no'} onClick={() => { closeDialogue() }}>
                        Άκυρο
                    </Button>
                </CardFooter>
            </Card>
        </div>
    )
}

export default NewGroupInput